<template>
  <div class="content container-fluid">
    <!-- Page Header -->
    <div class="page-header">
      <div class="row align-items-center">
        <div class="col">
          <h3 class="page-title">Customers</h3>
        </div>
        <div class="col-auto float-right ml-auto">
          <button class="btn add-btn" @click="add">
            <i class="fa fa-plus"></i>Add Customer
          </button>
        </div>
      </div>
    </div>
    <!-- /Page Header -->

    <!-- Search Filter -->
    <div class="row">
      <div class="col-md-3">
        <div class="form-group">
          <label>Name</label>
          <input
            type="text"
            class="form-control"
            v-model="name"
            maxlength="100"
          />
        </div>
      </div>
      <div class="col-md-3">
        <div class="form-group">
          <label>Email</label>
          <input
            type="text"
            class="form-control"
            v-model="email"
            maxlength="100"
          />
        </div>
      </div>
      <div class="col-md-2">
        <div class="form-group">
          <label>DOB from</label>
          <input type="date" class="form-control" v-model="dobFrom" />
        </div>
      </div>
      <div class="col-md-2">
        <div class="form-group">
          <label>DOB to</label>
          <input type="date" class="form-control" v-model="dobTo" />
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-2">
        <div class="form-group">
          <label>Gender</label>
          <select class="form-control" v-model="gender">
            <option value>All</option>
            <option value="Male">Male</option>
            <option value="Female">Female</option>
          </select>
        </div>
      </div>
      <div class="col-md-3">
        <div class="form-group">
          <label>Nationality</label>
          <Select2 v-model="nationalityId" :options="nationalities" />
        </div>
      </div>
      <div
        class="col-md-3"
        v-if="
          tokenObj.role == userRoleSuperAdmin || tokenObj.role == userRoleAdmin
        "
      >
        <div class="form-group">
          <label>Merchant Registered</label>
          <Select2 v-model="merchantId" :options="merchants" />
        </div>
      </div>
      <div class="col-md-2">
        <div class="form-group">
          <label>Status</label>
          <select class="form-control" v-model="status">
            <option value>All</option>
            <option value="Active">Active</option>
            <option value="Inactive">Inactive</option>
          </select>
        </div>
      </div>
      <div class="col-md-1">
        <button class="btn btn-primary filter-btn" @click="getCustomerList">
          Search
        </button>
      </div>
    </div>
    <!-- /Search Filter -->

    <!-- Pagination -->
    <div class="row mt-3">
      <div class="col-md-6">
        Show
        <select
          class="custom-select custom-select-sm"
          v-model="paging.SizePerPage"
          style="width: 5em"
        >
          <option
            v-for="item in paging.Sizes"
            v-bind:key="item"
            v-bind:value="item"
          >
            {{ item }}
          </option>
        </select>
        entries
      </div>
    </div>
    <!-- /Pagination -->

    <!-- Table List -->
    <div class="row mt-2">
      <div class="col-md-12">
        <div class="table-responsive mb-lg-0 mb-md-0 mb-sm-1">
          <table class="table table-bordered custom-table mb-0">
            <thead class="thead-light">
              <tr>
                <th class="no-col">No</th>
                <th>
                  <button class="btn p-0" @click="setSortBy('name')">
                    Name
                    <span class="tableHeaderSortIcon">
                      <i
                        class="fa fa-long-arrow-up ml-1"
                        :style="[
                          paging.SortBy === 'name'
                            ? { color: 'orange' }
                            : { color: 'white' },
                        ]"
                      ></i>
                      <i
                        class="fa fa-long-arrow-down"
                        :style="[
                          paging.SortBy === 'name_desc'
                            ? { color: 'orange' }
                            : { color: 'white' },
                        ]"
                      ></i>
                    </span>
                  </button>
                </th>
                <th>
                  <button class="btn p-0" @click="setSortBy('email')">
                    Email
                    <span class="tableHeaderSortIcon">
                      <i
                        class="fa fa-long-arrow-up ml-1"
                        :style="[
                          paging.SortBy === 'email'
                            ? { color: 'orange' }
                            : { color: 'white' },
                        ]"
                      ></i>
                      <i
                        class="fa fa-long-arrow-down"
                        :style="[
                          paging.SortBy === 'email_desc'
                            ? { color: 'orange' }
                            : { color: 'white' },
                        ]"
                      ></i>
                    </span>
                  </button>
                </th>
                <th>
                  <button class="btn p-0" @click="setSortBy('dob')">
                    Date of Birth
                    <span class="tableHeaderSortIcon">
                      <i
                        class="fa fa-long-arrow-up ml-1"
                        :style="[
                          paging.SortBy === 'dob'
                            ? { color: 'orange' }
                            : { color: 'white' },
                        ]"
                      ></i>
                      <i
                        class="fa fa-long-arrow-down"
                        :style="[
                          paging.SortBy === 'dob_desc'
                            ? { color: 'orange' }
                            : { color: 'white' },
                        ]"
                      ></i>
                    </span>
                  </button>
                </th>
                <th>
                  <button class="btn p-0" @click="setSortBy('gender')">
                    Gender
                    <span class="tableHeaderSortIcon">
                      <i
                        class="fa fa-long-arrow-up ml-1"
                        :style="[
                          paging.SortBy === 'gender'
                            ? { color: 'orange' }
                            : { color: 'white' },
                        ]"
                      ></i>
                      <i
                        class="fa fa-long-arrow-down"
                        :style="[
                          paging.SortBy === 'gender_desc'
                            ? { color: 'orange' }
                            : { color: 'white' },
                        ]"
                      ></i>
                    </span>
                  </button>
                </th>
                <th>
                  <button class="btn p-0" @click="setSortBy('nationality')">
                    Nationality
                    <span class="tableHeaderSortIcon">
                      <i
                        class="fa fa-long-arrow-up ml-1"
                        :style="[
                          paging.SortBy === 'nationality'
                            ? { color: 'orange' }
                            : { color: 'white' },
                        ]"
                      ></i>
                      <i
                        class="fa fa-long-arrow-down"
                        :style="[
                          paging.SortBy === 'nationality_desc'
                            ? { color: 'orange' }
                            : { color: 'white' },
                        ]"
                      ></i>
                    </span>
                  </button>
                </th>
                <th
                  v-if="
                    tokenObj.role == userRoleSuperAdmin ||
                    tokenObj.role == userRoleAdmin
                  "
                  style="width: 300px"
                >
                  <button class="btn p-0" @click="setSortBy('merchant')">
                    Merchant(s) Registered
                    <span class="tableHeaderSortIcon">
                      <i
                        class="fa fa-long-arrow-up ml-1"
                        :style="[
                          paging.SortBy === 'merchant'
                            ? { color: 'orange' }
                            : { color: 'white' },
                        ]"
                      ></i>
                      <i
                        class="fa fa-long-arrow-down"
                        :style="[
                          paging.SortBy === 'merchant_desc'
                            ? { color: 'orange' }
                            : { color: 'white' },
                        ]"
                      ></i>
                    </span>
                  </button>
                </th>
                <th>
                  <button class="btn p-0" @click="setSortBy('createdDate')">
                    Created Date
                    <span class="tableHeaderSortIcon">
                      <i
                        class="fa fa-long-arrow-up ml-1"
                        :style="[
                          paging.SortBy === 'createdDate'
                            ? { color: 'orange' }
                            : { color: 'white' },
                        ]"
                      ></i>
                      <i
                        class="fa fa-long-arrow-down"
                        :style="[
                          paging.SortBy === 'createdDate_desc'
                            ? { color: 'orange' }
                            : { color: 'white' },
                        ]"
                      ></i>
                    </span>
                  </button>
                </th>
                <th>
                  <button class="btn p-0" @click="setSortBy('lastLoginDate')">
                    Last Login Date
                    <span class="tableHeaderSortIcon">
                      <i
                        class="fa fa-long-arrow-up ml-1"
                        :style="[
                          paging.SortBy === 'lastLoginDate'
                            ? { color: 'orange' }
                            : { color: 'white' },
                        ]"
                      ></i>
                      <i
                        class="fa fa-long-arrow-down"
                        :style="[
                          paging.SortBy === 'lastLoginDate_desc'
                            ? { color: 'orange' }
                            : { color: 'white' },
                        ]"
                      ></i>
                    </span>
                  </button>
                </th>
                <th class="status-col">
                  <button class="btn p-0" @click="setSortBy('status')">
                    Status
                    <span class="tableHeaderSortIcon">
                      <i
                        class="fa fa-long-arrow-up ml-1"
                        :style="[
                          paging.SortBy === 'status'
                            ? { color: 'orange' }
                            : { color: 'white' },
                        ]"
                      ></i>
                      <i
                        class="fa fa-long-arrow-down"
                        :style="[
                          paging.SortBy === 'status_desc'
                            ? { color: 'orange' }
                            : { color: 'white' },
                        ]"
                      ></i>
                    </span>
                  </button>
                </th>
                <th class="action-col">Action</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(customer, i) in customers" :key="i">
                <td class="no-col">
                  {{
                    paging.CurrentPage * paging.SizePerPage -
                    paging.SizePerPage +
                    i +
                    1
                  }}
                </td>
                <td>{{ customer.name }}</td>
                <td>{{ customer.email }}</td>
                <td>{{ customer.dob_display }}</td>
                <td>{{ customer.gender }}</td>
                <td>{{ customer.nationality }}</td>
                <td
                  v-if="
                    tokenObj.role == userRoleSuperAdmin ||
                    tokenObj.role == userRoleAdmin
                  "
                >
                  {{ customer.merchants_display }}
                </td>
                <td>{{ customer.created_date }}</td>
                <td>{{ customer.last_login_date }}</td>
                <td>
                  <span
                    class="badge badge-pill"
                    :class="{
                      'badge-success': customer.status == statusActive,
                      'badge-danger': customer.status == statusInactive,
                    }"
                  >
                    {{ customer.status }}
                  </span>
                </td>
                <td class="action-col">
                  <label class="toggler">
                    <input
                      type="checkbox"
                      :checked="customer.status == statusActive"
                      @change="toggle(customer.id, $event)"
                    />
                    <span class="slider round"></span>
                  </label>
                  <button
                    class="btn btn-sm btn-primary mt-1"
                    @click="edit(customer)"
                  >
                    <i class="fa fa-pencil mr-1"></i>Edit
                  </button>
                  <button
                    class="btn btn-sm btn-danger mt-1"
                    @click="remove(customer.id)"
                  >
                    <i class="fa fa-trash-o mr-1"></i>Delete
                  </button>
                </td>
              </tr>
              <tr v-if="customers && !customers.length">
                <td colspan="11" class="text-center">
                  {{ noRecordText }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <!-- /Table List -->

    <!--Pagination -->
    <div class="row mb-4" v-if="customers && customers.length">
      <div
        class="col-md-6 col-lg-6 col-sm-6 my-auto text-center text-lg-left text-md-left"
      >
        Showing
        {{ paging.CurrentPage * paging.SizePerPage - paging.SizePerPage + 1 }}
        to
        {{
          paging.CurrentPage * paging.SizePerPage -
          paging.SizePerPage +
          customers.length
        }}
        of {{ totalRecords }} entries
      </div>

      <div class="col-md-6 col-lg-6 col-sm-6 pr-md-0 pr-lg-0">
        <div class="navbar justify-content-end">
          <button
            v-on:click="first()"
            v-if="paging.CurrentPage != 1"
            class="btn btn-sm btn-white"
          >
            First
          </button>
          <button
            v-on:click="prev()"
            class="btn btn-sm btn-white ml-1 mr-3"
            v-if="paging.CurrentPage > 1"
          >
            Prev
          </button>
          Page
          <input
            class="form-control form-control-sm mx-1"
            type="number"
            step="1"
            min="1"
            :max="paging.TotalPage"
            v-model="paging.CurrentPage"
            @change="onCurrentPageChange($event)"
            style="width: 4rem"
          />
          <span>of {{ paging.TotalPage }}</span>
          <button
            v-on:click="next()"
            class="btn btn-sm btn-white ml-3 mr-1"
            v-if="paging.CurrentPage < paging.TotalPage"
          >
            Next
          </button>
          <button
            v-on:click="last()"
            v-if="paging.CurrentPage != paging.TotalPage"
            class="btn btn-sm btn-white"
          >
            Last
          </button>
        </div>
      </div>
    </div>
    <!--/Pagination -->

    <!-- Add/Edit Customer Modal -->
    <div class="modal custom-modal fade" id="customerModal" role="dialog">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header pt-4">
            <h5 class="modal-title">
              {{ customer.id ? "Edit" : "Add" }} Customer
            </h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span>&times;</span>
            </button>
          </div>
          <div class="modal-body pt-3">
            <form @submit.prevent="save">
              <div class="form-group">
                <label>Name</label>
                <input
                  type="text"
                  v-model="customer.name"
                  class="form-control"
                  maxlength="100"
                  required
                />
              </div>
              <div class="form-group">
                <label>Email</label>
                <input
                  type="email"
                  v-model="customer.email"
                  class="form-control"
                  maxlength="100"
                  required
                />
              </div>
              <div class="form-group" v-if="!customer.id">
                <label>Password</label>
                <input
                  type="password"
                  v-model="customer.password"
                  class="form-control"
                  maxlength="50"
                  required
                />
              </div>
              <div class="form-row">
                <div class="form-group col-md-6">
                  <label>Date of Birth</label>
                  <input
                    type="date"
                    v-model="customer.dob"
                    class="form-control"
                  />
                </div>
                <div class="form-group col-md-6">
                  <label>Gender</label>
                  <select class="form-control" v-model="customer.gender">
                    <option value>-- Select Gender --</option>
                    <option value="Male">Male</option>
                    <option value="Female">Female</option>
                  </select>
                </div>
              </div>
              <div class="form-group">
                <label>Nationality</label>
                <v-select
                  v-model="customer.nationality"
                  :options="nationalitiesPopup"
                  label="text"
                >
                </v-select>
              </div>
              <div
                class="form-group"
                v-if="
                  tokenObj.role == userRoleSuperAdmin ||
                  tokenObj.role == userRoleAdmin
                "
              >
                <label>Merchant Registered</label>
                <multiselect
                  v-model="customer.merchantIds"
                  :options="merchantsPopup"
                  :multiple="true"
                  label="name"
                  track-by="id"
                ></multiselect>
              </div>
              <div class="submit-section mt-4">
                <button class="btn btn-primary submit-btn">
                  {{ customer.id ? "Update" : "Add" }}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
    <!-- /Add/Edit Customer Modal -->
  </div>
</template>

<script>
import API from "../../http-common.js";
import config from "../../config.js";
import Multiselect from "vue-multiselect";
import $ from "jquery";
export default {
  components: {
    Multiselect,
  },
  data() {
    return {
      noRecordText: config.NO_RECORD_TEXT,
      userRoleSuperAdmin: config.USER_ROLE_SUPER_ADMIN,
      userRoleAdmin: config.USER_ROLE_ADMIN,
      statusActive: config.STATUS_ACTIVE,
      statusInactive: config.STATUS_INACTIVE,
      customers: [],
      //popup
      nationalitiesPopup: [],
      merchantsPopup: [],
      customer: {
        id: "",
        name: "",
        email: "",
        password: "",
        dob: "",
        gender: "",
        nationality: null,
        merchantIds: [],
      },
      //pagination
      paging: {
        CurrentPage: 1,
        TotalPage: "",
        SizePerPage: 20,
        Sizes: [20, 50, 100],
        SortBy: "",
      },
      totalRecords: "",
      //filter
      name: "",
      email: "",
      dobFrom: "",
      dobTo: "",
      gender: "",
      merchants: [],
      merchantId: "0",
      nationalities: [],
      nationalityId: "0",
      status: "",
    };
  },
  computed: {
    tokenObj() {
      let data = JSON.parse(localStorage.getItem("emstoken"));
      return data;
    },
    config() {
      return { headers: { Authorization: `Bearer ${this.tokenObj.token}` } };
    },
  },
  watch: {
    "paging.SizePerPage": function () {
      this.paging.CurrentPage = 1;
      this.getCustomerList();
    },
    "paging.CurrentPage": function (val, oldVal) {
      if (val > this.paging.TotalPage) {
        this.paging.CurrentPage = this.paging.TotalPage;
      }
    },
  },
  methods: {
    //filter
    getNationalities() {
      API.getNationalities({}, this.config)
        .then((response) => {
          if (response.data.success) {
            this.nationalitiesPopup = [...response.data.records];
            response.data.records.unshift({ id: "0", text: "All" });
            this.nationalities = response.data.records;
          } else {
            this.$swal(response.data.message, { icon: "error" });
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    getMerchants() {
      API.getAllMerchants({}, this.config)
        .then((response) => {
          this.$store.state.isLoading = false;
          if (response.data.success) {
            this.merchantsPopup = [...response.data.records];
            response.data.records.unshift({ id: "0", text: "All" });
            this.merchants = response.data.records;
          } else {
            this.$swal(response.data.message, { icon: "error" });
          }
        })
        .catch((error) => {
          this.$store.state.isLoading = false;
          console.log(error);
        });
    },
    //main
    add() {
      this.customer = {
        id: "",
        name: "",
        email: "",
        password: "",
        dob: "",
        gender: "",
        nationality: null,
        merchantIds: [],
      };
      $("#customerModal").modal("show");
    },
    edit(payload) {
      this.customer.id = payload.id;
      this.customer.name = payload.name;
      this.customer.email = payload.email;
      this.customer.dob = payload.dob;
      this.customer.gender = payload.gender;
      this.customer.nationality = payload.nationality_id
        ? { id: payload.nationality_id, text: payload.nationality }
        : null;
      this.customer.merchantIds = payload.merchants;
      $("#customerModal").modal("show");
    },
    getCustomerList() {
      let param = {
        name: this.name,
        email: this.email,
        dob_from: this.dobFrom,
        dob_to: this.dobTo,
        gender: this.gender,
        merchant_id: this.merchantId == "0" ? "" : this.merchantId,
        nationality_id: this.nationalityId == "0" ? "" : this.nationalityId,
        status: this.status,
        current_page: this.paging.CurrentPage,
        total_page: this.paging.TotalPage,
        size_per_page: this.paging.SizePerPage,
        sort_by: this.paging.SortBy,
      };
      this.$store.state.isLoading = true;
      API.getCustomers(param, this.config)
        .then((response) => {
          this.$store.state.isLoading = false;
          if (response.data.success) {
            this.customers = response.data.records;
            this.totalRecords = response.data.total;
            this.paging.TotalPage = response.data.page_count;
            if (this.paging.CurrentPage > this.paging.TotalPage) {
              this.paging.CurrentPage = 1;
            }
          } else {
            this.$swal(response.data.message, { icon: "error" });
          }
        })
        .catch((error) => {
          this.$store.state.isLoading = false;
          console.log(error);
        });
    },
    save() {
      let param = {
        id: this.customer.id,
        name: this.customer.name,
        email: this.customer.email,
        dob: this.customer.dob,
        gender: this.customer.gender,
        nationality_id: this.customer.nationality
          ? this.customer.nationality.id
          : null,
        merchant_ids: this.customer.merchantIds.map((c) => c.id),
      };
      let action = this.customer.id ? "update" : "add";
      let text = `Are you sure you want to ${action} the customer?`;
      this.$swal({
        title: "Are you sure?",
        text: text,
        icon: "info",
        buttons: true,
        dangerMode: false,
      }).then((willSave) => {
        if (willSave) {
          this.$store.state.isLoading = true;
          API.saveCustomer(param, this.config)
            .then((response) => {
              this.$store.state.isLoading = false;
              this.$swal(response.data.message, {
                icon: response.data.success ? "success" : "error",
              });
              if (response.data.success) {
                this.getCustomerList();
                $("#customerModal").modal("hide");
              }
            })
            .catch((error) => {
              this.$store.state.isLoading = false;
              console.log(error);
            });
        }
      });
    },
    remove(id) {
      let param = { id: id };
      this.$swal({
        title: "Are you sure?",
        text: "Are you sure you want to delete the customer?",
        icon: "info",
        buttons: true,
        dangerMode: false,
      }).then((willDelete) => {
        if (willDelete) {
          this.$store.state.isLoading = true;
          API.deleteCustomer(param, this.config)
            .then((response) => {
              this.$store.state.isLoading = false;
              this.$swal(response.data.message, {
                icon: response.data.success ? "success" : "error",
              });
              if (response.data.success) {
                this.getCustomerList();
              }
            })
            .catch((error) => {
              this.$store.state.isLoading = false;
              console.log(error);
            });
        }
      });
    },
    toggle(id, $event) {
      let isActive = $event.target.checked;
      let param = {
        id: id,
        is_active: isActive,
      };
      this.$store.state.isLoading = true;
      API.toggleCustomer(param, this.config)
        .then((response) => {
          this.$store.state.isLoading = false;
          this.$swal(response.data.message, {
            icon: response.data.success ? "success" : "error",
          });
          if (response.data.success) {
            this.getCustomerList();
          }
        })
        .catch((error) => {
          this.$store.state.isLoading = false;
          console.log(error);
        });
    },
    //for pagination
    onCurrentPageChange(event) {
      let currentPage = event.target.value;
      if (currentPage < 1) {
        currentPage = 1;
      }
      this.paging.CurrentPage = parseInt(currentPage);
      this.getCustomerList();
    },
    first() {
      this.paging.CurrentPage = 1;
      this.getCustomerList();
    },
    prev() {
      this.paging.CurrentPage -= 1;
      this.getCustomerList();
    },
    next() {
      this.paging.CurrentPage += 1;
      this.getCustomerList();
    },
    last() {
      this.paging.CurrentPage = this.paging.TotalPage;
      this.getCustomerList();
    },
    setSortBy(payload) {
      switch (payload) {
        case "name":
          if (this.paging.SortBy === "name") {
            this.paging.SortBy = "name_desc";
          } else if (this.paging.SortBy === "name_desc") {
            this.paging.SortBy = "name";
          } else {
            this.paging.SortBy = "name";
          }
          break;
        case "email":
          if (this.paging.SortBy === "email") {
            this.paging.SortBy = "email_desc";
          } else if (this.paging.SortBy === "email_desc") {
            this.paging.SortBy = "email";
          } else {
            this.paging.SortBy = "email";
          }
          break;
        case "dob":
          if (this.paging.SortBy === "dob") {
            this.paging.SortBy = "dob_desc";
          } else if (this.paging.SortBy === "dob_desc") {
            this.paging.SortBy = "dob";
          } else {
            this.paging.SortBy = "dob";
          }
          break;
        case "gender":
          if (this.paging.SortBy === "gender") {
            this.paging.SortBy = "gender_desc";
          } else if (this.paging.SortBy === "gender_desc") {
            this.paging.SortBy = "gender";
          } else {
            this.paging.SortBy = "gender";
          }
          break;
        case "nationality":
          if (this.paging.SortBy === "nationality") {
            this.paging.SortBy = "nationality_desc";
          } else if (this.paging.SortBy === "nationality_desc") {
            this.paging.SortBy = "nationality";
          } else {
            this.paging.SortBy = "nationality";
          }
          break;
        case "merchant":
          if (this.paging.SortBy === "merchant") {
            this.paging.SortBy = "merchant_desc";
          } else if (this.paging.SortBy === "merchant_desc") {
            this.paging.SortBy = "merchant";
          } else {
            this.paging.SortBy = "merchant";
          }
          break;
        case "createdDate":
          if (this.paging.SortBy === "createdDate") {
            this.paging.SortBy = "createdDate_desc";
          } else if (this.paging.SortBy === "createdDate_desc") {
            this.paging.SortBy = "createdDate";
          } else {
            this.paging.SortBy = "createdDate";
          }
          break;
        case "lastLoginDate":
          if (this.paging.SortBy === "lastLoginDate") {
            this.paging.SortBy = "lastLoginDate_desc";
          } else if (this.paging.SortBy === "lastLoginDate_desc") {
            this.paging.SortBy = "lastLoginDate";
          } else {
            this.paging.SortBy = "lastLoginDate";
          }
          break;
        case "status":
          if (this.paging.SortBy === "status") {
            this.paging.SortBy = "status_desc";
          } else if (this.paging.SortBy === "status_desc") {
            this.paging.SortBy = "status";
          } else {
            this.paging.SortBy = "status";
          }
          break;
      }
      this.getCustomerList();
    },
  },
  created() {
    this.getNationalities();
    this.getMerchants();
    this.getCustomerList();
  },
};
</script>

<style scoped>
/* .table-responsive {
  white-space: unset;
}
table{
  width: 1800px;
} */
</style>


// WEBPACK FOOTER //
// src/components/Share/CustomerList.vue